<template>
  <div>
    <base-title :title="'Relatórios'"></base-title>
    <div class="reports">
      <div class="item" @click="changeRoute('faturamento')">
        <div class="icon">
          <i class="fal fa-sack-dollar"></i>
        </div>
        {{ StringLanguage.storeBilling }}
      </div>
      <div class="item" @click="changeRoute('relatorio-clientes')">
        <div class="icon">
          <i class="fal fa-users"></i>
        </div>
        {{ StringLanguage.registeredCustomers }}
      </div>
      <div class="item" @click="changeRoute('relatorio-pedidos')">
        <div class="icon">
          <i class="fal fa-file-check"></i>
        </div>
        {{ StringLanguage.finishedOrders }}
      </div>
      <div class="item" @click="changeRoute('pesquisa-satisfacao')">
        <div class="icon">
          <i class="fal fa-star"></i>
        </div>
        {{ StringLanguage.satisfactionSurvey }}
      </div>
      <!-- REMOVIDO PELA ATIVIDADE EASY-1550
      <div class="item" @click="changeRoute('produtos-cardapio')">
        <div class="icon">
          <i class="fal fa-list-ul"></i>
        </div>
        {{ StringLanguage.productsSold }}
      </div>
      -->
    </div>
  </div>
</template>

<script>
import BaseTitle from '@/components/Title';

export default {
  components: {
    BaseTitle,
  },
  methods: {
    changeRoute(routeName, params) {
      if (params) {
        return this.$router.push({ name: routeName, params });
      }
      this.$router.push({ name: routeName });
    },
  },
};
</script>

<style scoped>
.reports {
  display: flex;
  flex-wrap: wrap;
}

.reports .item {
  background-color: #414147;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
  flex: 0 32%;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.reports .item:hover {
  background-color: #3d3d42;
}

.reports .item .icon {
  width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.reports .item:not(:nth-child(3n)) {
  margin-right: 20px;
}

.reports .item {
  color: #999999;
  font-size: 14px;
}

.reports .item .icon i {
  color: #999999;
  font-size: 17px;
}

.reports .item:hover,
.reports .item:hover i {
  color: var(--default);
}

@media screen and (max-width: 1149px) {
  .reports .item {
    flex: 1 47%;
  }
  .reports .item:nth-child(1n) {
    margin-right: 20px;
  }
}

@media screen and (max-width: 991px) {
  .reports .item {
    flex: 1 100%;
  }
  .reports .item:nth-child(1n),
  .reports .item:not(:nth-child(3n)) {
    margin-right: 0;
  }
}
</style>
